import CookiesNotEnabledWarning from './CookiesNotEnabledWarning'
export default CookiesNotEnabledWarning
